<template>
	<mdb-row class="bg-white">
		<mdb-col col="12" class="mr-2">
			<mdb-row>
				<mdb-col>
					<mdb-select :btn-save="false" :options="rulesetsOptions" @change="select"></mdb-select>
				</mdb-col>
			</mdb-row>
			<template v-if="ruleset">
				<mdb-row>
					<mdb-col>
						<mdb-input label="name" :value="ruleset.name" @change="updateName"></mdb-input>
					</mdb-col>
				</mdb-row>
				<mdb-row class="justify-content-center">
					<draggable v-bind="dragOptions" item-key="rules" class="col" :list="rulesetRules(ruleset)" :move="onMove" @change="onChange({ rulesetName: ruleset.name }, $event)" :componentData="{ rulesetName: ruleset.name }">
						<template #item="{ element }">
							<rule :key="element.name" :rule="element" class="mx-1 my-2" @delete="excludeRule({ rulesetName: ruleset.name, name: element.name })"></rule>
						</template>
					</draggable>
				</mdb-row>
				<mdb-row>
					<mdb-col>
						<mdb-select v-if="rulesOptions.length" :btn-save="false" :options="rulesOptions" @change="onRuleSelect"></mdb-select>
					</mdb-col>
				</mdb-row>
				<mdb-icon color="default" icon="times-circle" @click="remove" class="c-pointer position-absolute left-top"></mdb-icon>
			</template>
			<template v-else>
				<mdb-row>
					<mdb-col>
						<mdb-input label="name" @change="saveRuleset"></mdb-input>
					</mdb-col>
				</mdb-row>
			</template>
		</mdb-col>
	</mdb-row>
</template>

<script>
import Draggable from 'vuedraggable'
import {mdbIcon, mdbInput, mdbSelect} from '@/components/mdbvue'
import {mapActions, mapMutations, mapState} from 'vuex'

import Rule from './Rule.vue'

export default {
	name: 'Rulesets',
	components: { mdbIcon, mdbInput, mdbSelect, Draggable, Rule },
	async created () {
		await this.fetchRules()
		await this.fetchRulesets()
	},
	computed: {
		ruleset () {
			return this.rulesetName && this.rulesets[this.rulesetName]
		},
		rulesetsOptions () {
			return [{ text: this.$t('rules.rulesets.new', this.locale), value: null, selected: this.rulesetName === null }].concat(Object.values(this.rulesets).map(r => ({ text: r.name, value: r.name, selected: r.name === this.rulesetName })))
		},
		rulesOptions () {
			return [{ text: "Select rule to be added", value: null, selected: true }, ...Object.values(this.rules).map(r => ({ text: r.name, value: r.name, disabled: this.ruleset.rules.includes(r.name) }))]
		},
		dragOptions () {
			return {
				animation: 0,
				disabled: false,
				draggable: '.rule-wrapper',
				group: 'rules',
				ghostClass: 'ghost',
				tag: 'div'
			}
		},
		...mapState(['locale']),
		...mapState('rules', ['rules', 'rulesets', 'rulesetName'])
	},
	methods: {
		select (rulesetName) {
			this.SET_RULESET_NAME(rulesetName)
		},
		async updateName (value) {
			if (value !== this.ruleset.name && value !== '') {
				await this.updateRuleset(Object.assign({}, this.ruleset, { name: value }))
			}
		},
		async saveRuleset (value) {
			if (typeof value === 'object') {
				value = value.target.value
			}
			if (value !== '') {
				const ruleset = await this.updateRuleset({ name: value, rules: [] })
				this.SET_RULESET_NAME(ruleset.name)
			}
		},
		async remove () {
			if (confirm(this.$t('common.confirm-removal', this.locale))) {
				await this.deleteRuleset(this.ruleset)
			}
		},
		rulesetRules (ruleset) {
			return ruleset.rules.map(name => Object.assign({}, this.rules[name], { rulesetName: ruleset.name }))
		},
		onMove ({ relatedContext, draggedContext }) {
			if (!draggedContext.element) {
				console.warn('Warning! Dragged context has no element! See dragged context contents below:')
				console.warn(draggedContext)
				return false
			} else {
				return relatedContext.component.componentData.rulesetName === draggedContext.element.rulesetName
			}
		},
		async onChange ({ rulesetName }, event) {
			let eventData
			if ('moved' in event) {
				eventData = event.moved
			} else if ('added' in event) {
				eventData = event.added
			} else {
				return
			}
			await this.replaceRule({rulesetName, name: eventData.element.name, value: eventData.newIndex})
		},
		async onRuleSelect (name) {
			if (name !== null) {
				await this.includeRule({rulesetName: this.ruleset.name, name})
			}
		},
		async excludeRule ({ rulesetName, name }) {
			await this.replaceRule({rulesetName, name, value: null})
		},
		...mapActions('rules', ['fetchRules', 'fetchRulesets', 'updateRuleset', 'deleteRuleset', 'includeRule', 'replaceRule']),
		...mapMutations('rules', ['SET_RULESET_NAME'])
	}
}
</script>

<style scoped>

</style>
